(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useAffiliateTracking; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var useAffiliateTracking = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var queryValue = router.query.a;
        var affiliateTagCode = typeof queryValue === "string" ? queryValue : undefined;
        if (affiliateTagCode) {
            var thirtyDays = 30 * 24 * 60 * 60;
            (0,nookies__WEBPACK_IMPORTED_MODULE_1__.setCookie)(null, "affiliate_tag", affiliateTagCode, {
                maxAge: thirtyDays,
                path: "/",
                secure:  true && window.location.protocol === "https:",
                sameSite: "lax"
            });
        }
    }, [
        router.query.a
    ]);
    var getAffiliateTagCode = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_1__.parseCookies)();
        return cookies.affiliate_tag || null;
    }, []);
    return {
        getAffiliateTagCode: getAffiliateTagCode
    };
};


/***/ }),

/***/ 8335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ setSpaceRedirectUrl; }
/* harmony export */ });
/**
 * LocalStorageにリダイレクトURLをセットする
 */ function setSpaceRedirectUrl() {
    var localStorageParams = JSON.parse(localStorage.getItem("search_params") || "{}");
    localStorageParams.redirect_url = location.href;
    localStorage.setItem("search_params", JSON.stringify(localStorageParams));
}


/***/ }),

/***/ 30441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_setSpaceRedirectUrl__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(8335);
/* harmony import */ var components_commons_layouts_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58909);
/* harmony import */ var components_domains_top_SearchSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75920);
/* harmony import */ var components_domains_top_StoreSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33396);
/* harmony import */ var components_domains_top_MainBannerSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22803);
/* harmony import */ var components_domains_top_UsageSection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16822);
/* harmony import */ var components_domains_top_FeatureSection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32938);
/* harmony import */ var components_domains_top_LocationDisplaySection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3107);
/* harmony import */ var components_domains_top_CostSection__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61611);
/* harmony import */ var components_domains_top_ReviewSection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(91249);
/* harmony import */ var components_domains_top_OwnerSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94738);
/* harmony import */ var components_domains_top_CountrySection__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87396);
/* harmony import */ var providers_AuthProvider__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85993);
/* harmony import */ var hooks_common_intercom__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(60966);
/* harmony import */ var hooks_tracking_useAffiliateTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64007);
/* harmony import */ var features_country_hooks_useCountries__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23378);
/* harmony import */ var lib_meta__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22923);
/* harmony import */ var features_prefecture_hooks_usePrefectures__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(55213);
/* harmony import */ var features_prefecture_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(59658);
/* harmony import */ var _styles_index_module_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(44301);
/* harmony import */ var _styles_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_styles_index_module_scss__WEBPACK_IMPORTED_MODULE_23__);




moment__WEBPACK_IMPORTED_MODULE_3___default().locale("ja");




















var Top = function(param) {
    var locale = param.locale;
    (0,hooks_tracking_useAffiliateTracking__WEBPACK_IMPORTED_MODULE_17__/* .useAffiliateTracking */ .H)();
    var isSigned = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_AuthProvider__WEBPACK_IMPORTED_MODULE_15__/* .AuthContext */ .V).isSigned;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var prefectures = (0,features_prefecture_hooks_usePrefectures__WEBPACK_IMPORTED_MODULE_20__/* .usePrefectures */ .w)({
        countryId: features_prefecture_constants__WEBPACK_IMPORTED_MODULE_21__/* .JP_COUNTRY_ID */ .tP
    }).prefectures;
    var countries = (0,features_country_hooks_useCountries__WEBPACK_IMPORTED_MODULE_18__/* .useCountries */ .F)().countries;
    //Locationまでスクロール用のDomを生成
    var refTopLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var scrollLocationSection = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        refTopLocation.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, [
        refTopLocation
    ]);
    //預かり場所
    var locations = [
        {
            name: t("TOP.LOCATION.TOKYO"),
            slug: "tokyo/1",
            lat: 35.681236,
            lon: 139.767125,
            backgroundImage: 'url("/tokyo.webp") no-repeat'
        },
        {
            name: t("TOP.LOCATION.OSAKA"),
            slug: "osaka/20",
            lat: 34.7334658,
            lon: 135.5002547,
            backgroundImage: 'url("/osaka.webp") no-repeat'
        },
        {
            name: t("TOP.LOCATION.KYOTO"),
            slug: "kyoto/2",
            lat: 34.985849,
            lon: 135.7587667,
            backgroundImage: 'url("/kyoto.webp") no-repeat'
        },
        {
            name: t("TOP.LOCATION.FUKUOKA"),
            slug: "fukuoka/79",
            lat: 33.5897275,
            lon: 130.4207274,
            backgroundImage: 'url("/fukuoka.webp") no-repeat'
        },
        {
            name: t("TOP.LOCATION.NAGOYA"),
            slug: "aichi/3",
            lat: 35.170915,
            lon: 136.8815369,
            backgroundImage: 'url("/nagoya.webp") no-repeat'
        },
        {
            name: t("TOP.LOCATION.SAPPORO"),
            slug: "hokkaido/14",
            lat: 43.0686606,
            lon: 141.3507552,
            backgroundImage: 'url("/sapporo.webp") no-repeat'
        }, 
    ];
    var openIntercomMessage = (0,hooks_common_intercom__WEBPACK_IMPORTED_MODULE_16__/* .useCustomIntercom */ .j)().openIntercomMessage;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        openIntercomMessage();
        (0,lib_setSpaceRedirectUrl__WEBPACK_IMPORTED_MODULE_22__/* .setSpaceRedirectUrl */ .t)();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_commons_layouts_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lib_meta__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                title: t("META.TITLE.TOP_PAGE"),
                description: t("META.DESCRIPTION.TOP_PAGE"),
                url: "/".concat(locale === "default" ? "ja" : locale)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default().wrap),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_SearchSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        locale: locale
                    }),
                    locale === "ja" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_MainBannerSection__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        locale: locale
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_StoreSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                    !isSigned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_UsageSection__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        style: locale === "ja" && (_styles_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default().usageSection)
                    }),
                    !isSigned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_FeatureSection__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        countryCode: "jpn"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "scroll-location-section",
                        ref: refTopLocation
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_LocationDisplaySection__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        locations: locations,
                        prefectures: prefectures !== null && prefectures !== void 0 ? prefectures : [],
                        locale: locale,
                        countryCode: "jpn",
                        onScrollLocation: scrollLocationSection
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_CostSection__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
                    (locale === "ja" || locale === "en") && !isSigned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_ReviewSection__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}),
                    !isSigned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_OwnerSection__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
                    countries && countries.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_top_CountrySection__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        countries: countries,
                        locale: locale
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Top);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,1423,1580,3253,9882,5769,1336,2948,734,6637,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);